<template>
  <div class="slogan">
    <div v-if="showInsurance" class="insurance">
      <img src="../assets/bottom-tips.png" alt="美团支付" />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'IndexSlogan',

  props: {
    showInsurance: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  methods: {},
});
</script>

<style lang="less" scoped>
.slogan {
  position: absolute;
  left: 0;
  bottom: 0.8rem;
  width: 100%;
  text-align: center;
  .insurance {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      display: block;
      width: 2.71rem;
      height: 0.77rem;
      opacity: 0.7;
    }
  }
}
</style>
